import { useContext, useState } from "react";
import { useIntl } from "react-intl";
import { Box, Button, Menu, MenuItem, Tooltip } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import {
  LangContext,
  supportedLanguages,
  supportedLanguagesWithLabel,
} from "../../I18nProvider";
import styles from "../LanguageSwitcher/LanguageSwitcher.module.scss";

export const LanguageSwitcher = () => {
  const intl = useIntl();
  const { setLanguage, language } = useContext(LangContext);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const label = intl.formatMessage({
    id: "actions.change-language",
    defaultMessage: "Change language",
  });

  return (
    <Box className={styles.langBtnGroup}>
      <Tooltip title={label}>
        <Button
          id="language-switcher-button"
          aria-label={label}
          aria-controls={open ? "language-switcher-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={(event) => setAnchorEl(event.currentTarget)}
          startIcon={<LanguageIcon />}
          className={styles.langBtn}
        >
          {supportedLanguagesWithLabel.get(language)}
        </Button>
      </Tooltip>
      <Menu
        id="language-switcher-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{ "aria-labelledby": "language-switcher-button" }}
        slotProps={{ paper: { className: styles.langMenu } }}
      >
        {supportedLanguages.map((lang) => (
          <MenuItem
            key={lang}
            lang={lang}
            selected={lang === language}
            onClick={() => {
              setAnchorEl(null);
              setLanguage(lang);
            }}
          >
            {supportedLanguagesWithLabel.get(lang)}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
